/**
 * Signature Collection — Box Size ATC workflow.
 * Step 1: visual Box Size cards → Step 2: shipping (same modal) → product-form submit.
 */
(function () {
  "use strict";

  var ROOT_ID = "ks-box-size-atc-workflow";
  var CONFIG_SELECTOR = "[data-ks-box-size-atc-workflow-config]";

  function getConfig(fromEl) {
    var root =
      (fromEl && fromEl.closest && fromEl.closest(".shopify-section")) ||
      document;
    var node = root.querySelector
      ? root.querySelector(CONFIG_SELECTOR)
      : null;
    if (!node) node = document.querySelector(CONFIG_SELECTOR);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (_) {
      return null;
    }
  }

  function getKS() {
    return window.KSShippingOption || null;
  }

  function getGate() {
    return window.KSShippingGate || null;
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  var WorkflowUI = {
    root: null,
    panel: null,
    eyebrowEl: null,
    titleEl: null,
    productEl: null,
    helperEl: null,
    sizeStep: null,
    sizeMount: null,
    shippingStep: null,
    shippingOptions: null,
    estimateWrap: null,
    estimateValue: null,
    errorEl: null,
    backBtn: null,
    primaryBtn: null,
    cancelBtn: null,
    previousFocus: null,
    keyHandler: null,
    config: null,
    form: null,
    productFormHost: null,
    selectedVariantId: "",
    selectedShipping: "",
    step: "size",
    transitioning: false,

    ensureMounted: function () {
      if (this.root) return;

      var html =
        '<div id="' +
        ROOT_ID +
        '" class="ks-box-size-atc-workflow" hidden>' +
        '<div class="ks-box-size-atc-workflow__backdrop" data-ks-wf-close tabindex="-1"></div>' +
        '<div class="ks-box-size-atc-workflow__panel" role="dialog" aria-modal="true" aria-labelledby="ks-box-size-atc-workflow-title">' +
        '<button type="button" class="ks-box-size-atc-workflow__close modal__close-button" data-ks-wf-close aria-label="Close">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close"><use href="#icon-close" /></svg>' +
        "</button>" +
        '<p class="ks-box-size-atc-workflow__eyebrow" data-ks-wf-eyebrow>Step 1 of 2</p>' +
        '<h2 id="ks-box-size-atc-workflow-title" class="ks-box-size-atc-workflow__title" data-ks-wf-title>Choose your box size</h2>' +
        '<p class="ks-box-size-atc-workflow__product" data-ks-wf-product hidden></p>' +
        '<p class="ks-box-size-atc-workflow__helper" data-ks-wf-helper></p>' +
        '<div class="ks-box-size-atc-workflow__steps">' +
        '<div class="ks-box-size-atc-workflow__step is-active" data-ks-wf-step="size">' +
        '<div data-ks-wf-size-mount></div>' +
        "</div>" +
        '<div class="ks-box-size-atc-workflow__step" data-ks-wf-step="shipping" hidden>' +
        '<div class="ks-box-size-atc-workflow__options" data-ks-wf-shipping-options role="radiogroup" aria-label="Shipping option"></div>' +
        '<div class="ks-box-size-atc-workflow__estimate" data-ks-wf-estimate-wrap hidden>' +
        '<span class="ks-box-size-atc-workflow__estimate-label">Estimated ship date:</span>' +
        '<strong class="ks-box-size-atc-workflow__estimate-value" data-ks-wf-estimate></strong>' +
        "</div>" +
        "</div>" +
        "</div>" +
        '<p class="ks-box-size-atc-workflow__error" data-ks-wf-error role="alert" hidden></p>' +
        '<div class="ks-box-size-atc-workflow__actions">' +
        '<button type="button" class="button button--secondary" data-ks-wf-cancel>Cancel</button>' +
        '<button type="button" class="button button--secondary" data-ks-wf-back hidden>Back</button>' +
        '<button type="button" class="button button--primary" data-ks-wf-primary>Continue</button>' +
        "</div>" +
        "</div>" +
        "</div>";

      document.body.insertAdjacentHTML("beforeend", html);

      this.root = document.getElementById(ROOT_ID);
      this.panel = this.root.querySelector(".ks-box-size-atc-workflow__panel");
      this.eyebrowEl = this.root.querySelector("[data-ks-wf-eyebrow]");
      this.titleEl = this.root.querySelector("[data-ks-wf-title]");
      this.productEl = this.root.querySelector("[data-ks-wf-product]");
      this.helperEl = this.root.querySelector("[data-ks-wf-helper]");
      this.sizeStep = this.root.querySelector('[data-ks-wf-step="size"]');
      this.sizeMount = this.root.querySelector("[data-ks-wf-size-mount]");
      this.shippingStep = this.root.querySelector(
        '[data-ks-wf-step="shipping"]'
      );
      this.shippingOptions = this.root.querySelector(
        "[data-ks-wf-shipping-options]"
      );
      this.estimateWrap = this.root.querySelector("[data-ks-wf-estimate-wrap]");
      this.estimateValue = this.root.querySelector("[data-ks-wf-estimate]");
      this.errorEl = this.root.querySelector("[data-ks-wf-error]");
      this.backBtn = this.root.querySelector("[data-ks-wf-back]");
      this.primaryBtn = this.root.querySelector("[data-ks-wf-primary]");
      this.cancelBtn = this.root.querySelector("[data-ks-wf-cancel]");

      this.buildShippingOptions();

      var self = this;
      this.root.addEventListener("click", function (event) {
        if (event.target.closest("[data-ks-wf-close], [data-ks-wf-cancel]")) {
          event.preventDefault();
          self.close();
          return;
        }

        if (event.target.closest("[data-ks-wf-back]")) {
          event.preventDefault();
          self.goToSizeStep();
          return;
        }

        if (event.target.closest("[data-ks-wf-primary]")) {
          event.preventDefault();
          self.onPrimary();
          return;
        }

        var shipBtn = event.target.closest(".ks-box-size-atc-workflow__option");
        if (shipBtn) {
          event.preventDefault();
          self.selectShipping(shipBtn.dataset.value);
        }
      });

      this.root.addEventListener("change", function (event) {
        var radio = event.target.closest(
          '.ks-box-size-options input[type="radio"]'
        );
        if (!radio) return;
        self.onSizeSelected(radio);
      });

      this.keyHandler = function (event) {
        if (!self.root || self.root.hidden) return;
        if (event.code === "Escape") {
          event.preventDefault();
          self.close();
          return;
        }
        if (event.code === "Tab") {
          self.trapFocus(event);
        }
      };
      document.addEventListener("keydown", this.keyHandler);
    },

    buildShippingOptions: function () {
      if (!this.shippingOptions) return;
      this.shippingOptions.innerHTML = "";
      var KS = getKS();
      var options = KS ? KS.getShippingOptions() : [];

      options.forEach(function (value) {
        var est = KS.getEstimatedShipDateForOption(value);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "ks-box-size-atc-workflow__option";
        btn.setAttribute("role", "radio");
        btn.setAttribute("aria-checked", "false");
        btn.dataset.value = value;
        btn.innerHTML =
          '<span class="ks-box-size-atc-workflow__option-label">' +
          value +
          "</span>" +
          '<span class="ks-box-size-atc-workflow__option-date">' +
          est +
          "</span>";
        this.shippingOptions.appendChild(btn);
      }, this);
    },

    applyAccent: function (color) {
      if (!this.root || !color) return;
      this.root.style.setProperty("--ks-wf-accent", color);
      this.root.style.setProperty(
        "--ks-wf-accent-soft",
        "color-mix(in srgb, " + color + " 12%, white)"
      );
    },

    showError: function (message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || "";
      this.errorEl.hidden = !message;
    },

    onSizeSelected: function (radio) {
      if (!radio || radio.disabled) return;
      this.selectedVariantId = radio.getAttribute("data-variant-id") || "";
      this.showError("");
    },

    selectShipping: function (value) {
      var KS = getKS();
      this.selectedShipping = KS
        ? KS.normalizeShippingOption(value || "")
        : String(value || "").trim();

      this.root
        .querySelectorAll(".ks-box-size-atc-workflow__option")
        .forEach(
          function (btn) {
            var active = btn.dataset.value === this.selectedShipping;
            btn.classList.toggle("is-selected", active);
            btn.setAttribute("aria-checked", active ? "true" : "false");
          }.bind(this)
        );

      var estimated = KS
        ? KS.getEstimatedShipDateForOption(this.selectedShipping)
        : "";
      if (estimated && this.estimateWrap && this.estimateValue) {
        this.estimateValue.textContent = estimated;
        this.estimateWrap.hidden = false;
      } else if (this.estimateWrap) {
        this.estimateWrap.hidden = true;
      }

      this.showError("");
    },

    setStepChrome: function (step) {
      var cfg = this.config || {};
      this.step = step;

      if (step === "size") {
        if (this.eyebrowEl) this.eyebrowEl.textContent = "Step 1 of 2";
        if (this.titleEl) {
          this.titleEl.textContent = cfg.workflowTitle || "Choose your box size";
        }
        if (this.helperEl) {
          this.helperEl.textContent =
            cfg.workflowHelper ||
            "Select the box size that fits your table.";
        }
        if (this.primaryBtn) {
          this.primaryBtn.textContent = cfg.confirmSizeLabel || "Continue";
        }
        if (this.backBtn) this.backBtn.hidden = true;
        if (this.cancelBtn) this.cancelBtn.hidden = false;
      } else {
        if (this.eyebrowEl) this.eyebrowEl.textContent = "Step 2 of 2";
        if (this.titleEl) {
          this.titleEl.textContent =
            cfg.shippingTitle || "Choose shipping option";
        }
        if (this.helperEl) {
          this.helperEl.textContent =
            cfg.shippingHelper ||
            "We ship seafood on Mondays and Tuesdays to protect quality in transit.";
        }
        if (this.primaryBtn) {
          this.primaryBtn.textContent =
            cfg.confirmShippingLabel || "Add to cart";
        }
        if (this.backBtn) {
          this.backBtn.hidden = false;
          this.backBtn.textContent = cfg.backLabel || "Back";
        }
        if (this.cancelBtn) this.cancelBtn.hidden = true;
      }

      this.updateActionGrid();
    },

    updateActionGrid: function () {
      var actions = this.root.querySelector(
        ".ks-box-size-atc-workflow__actions"
      );
      if (!actions) return;
      var visible = Array.prototype.filter.call(actions.children, function (el) {
        return !el.hidden;
      });
      actions.style.gridTemplateColumns =
        visible.length > 2
          ? "1fr 1fr 1.2fr"
          : visible.length === 1
            ? "1fr"
            : "1fr 1fr";
    },

    goToSizeStep: function () {
      var self = this;
      this.showError("");
      this.transitionSteps(this.shippingStep, this.sizeStep, function () {
        self.setStepChrome("size");
        var checked = self.sizeMount.querySelector(
          'input[type="radio"]:checked:not(:disabled)'
        );
        (checked || self.sizeMount.querySelector("input[type='radio']"))?.focus?.(
          { preventScroll: true }
        );
      });
    },

    goToShippingStep: function () {
      var self = this;
      var KS = getKS();
      this.showError("");

      if (KS && KS.hasStoredOption()) {
        this.selectShipping(KS.getStoredOption());
      } else {
        this.selectShipping("");
        if (this.estimateWrap) this.estimateWrap.hidden = true;
      }

      this.transitionSteps(this.sizeStep, this.shippingStep, function () {
        self.setStepChrome("shipping");
        var focusTarget =
          self.root.querySelector(
            ".ks-box-size-atc-workflow__option.is-selected"
          ) || self.root.querySelector(".ks-box-size-atc-workflow__option");
        focusTarget?.focus?.({ preventScroll: true });
      });
    },

    transitionSteps: function (fromEl, toEl, done) {
      if (!fromEl || !toEl) {
        if (done) done();
        return;
      }

      if (prefersReducedMotion() || this.transitioning) {
        fromEl.hidden = true;
        fromEl.classList.remove("is-active", "is-leaving", "is-entering");
        toEl.hidden = false;
        toEl.classList.add("is-active");
        toEl.classList.remove("is-leaving", "is-entering");
        if (done) done();
        return;
      }

      var self = this;
      this.transitioning = true;
      fromEl.classList.add("is-leaving");

      window.setTimeout(function () {
        fromEl.hidden = true;
        fromEl.classList.remove("is-active", "is-leaving");
        toEl.hidden = false;
        toEl.classList.add("is-entering");
        requestAnimationFrame(function () {
          toEl.classList.add("is-active");
          toEl.classList.remove("is-entering");
          self.transitioning = false;
          if (done) done();
        });
      }, 180);
    },

    needsShippingStep: function () {
      var Gate = getGate();
      var form = this.form;
      if (!form || !Gate) return false;
      if (!Gate.formRequiresShipping(form, this.productFormHost)) return false;

      var cfg = this.config || {};
      if (cfg.alwaysShowShipping) return true;

      var KS = getKS();
      return !(KS && KS.hasStoredOption());
    },

    onPrimary: function () {
      if (this.step === "size") {
        this.confirmSize();
      } else {
        this.confirmShipping();
      }
    },

    confirmSize: function () {
      var checked = this.sizeMount.querySelector(
        'input[type="radio"]:checked:not(:disabled)'
      );
      if (!checked || !checked.getAttribute("data-variant-id")) {
        this.showError("Please choose a box size to continue.");
        var first = this.sizeMount.querySelector(
          'input[type="radio"]:not(:disabled)'
        );
        first?.focus?.();
        return;
      }

      this.selectedVariantId = checked.getAttribute("data-variant-id");
      this.applyVariantToForm();

      if (this.needsShippingStep()) {
        this.goToShippingStep();
        return;
      }

      this.finishAndSubmit();
    },

    confirmShipping: function () {
      var KS = getKS();
      if (
        !this.selectedShipping ||
        (KS && !KS.isValidShippingOption(this.selectedShipping))
      ) {
        this.showError(
          "Please choose a shipping option before adding this item to your cart."
        );
        this.root
          .querySelector(".ks-box-size-atc-workflow__option")
          ?.focus?.();
        return;
      }

      this.finishAndSubmit();
    },

    applyVariantToForm: function () {
      if (!this.form || !this.selectedVariantId) return;
      var idInput =
        this.form.querySelector("[data-ks-box-size-variant-id]") ||
        this.form.querySelector('[name="id"]');
      if (idInput) {
        idInput.value = this.selectedVariantId;
        idInput.removeAttribute("disabled");
      }
    },

    finishAndSubmit: function () {
      var self = this;
      var Gate = getGate();
      var KS = getKS();

      this.applyVariantToForm();

      var afterPersist = function () {
        self.close();
        if (!self.form) return;

        if (typeof self.form.requestSubmit === "function") {
          var submitBtn = self.form.querySelector(
            "[data-ks-box-size-form-submit]"
          );
          if (submitBtn) {
            self.form.requestSubmit(submitBtn);
          } else {
            self.form.requestSubmit();
          }
        } else {
          self.form.dispatchEvent(
            new Event("submit", { bubbles: true, cancelable: true })
          );
        }
      };

      if (
        this.selectedShipping &&
        Gate &&
        typeof Gate.persistSelection === "function"
      ) {
        var result = Gate.buildResult
          ? Gate.buildResult(this.selectedShipping)
          : {
              shippingValue: this.selectedShipping,
              estimatedShipDate: KS
                ? KS.getEstimatedShipDateForOption(this.selectedShipping)
                : "",
            };
        Gate.persistSelection(result).then(afterPersist).catch(afterPersist);
        return;
      }

      if (this.selectedShipping && KS) {
        KS.saveStoredOption(this.selectedShipping);
        KS.syncCartAttribute(this.selectedShipping)
          .catch(function () {})
          .then(afterPersist);
        return;
      }

      afterPersist();
    },

    trapFocus: function (event) {
      var focusables = this.panel.querySelectorAll(
        'button:not([hidden]):not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      var list = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!list.length) return;

      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    open: function (options) {
      options = options || {};
      this.ensureMounted();

      this.config = options.config || getConfig() || {};
      this.form = options.form || null;
      this.productFormHost = this.form
        ? this.form.closest("product-form") || this.form
        : null;
      this.previousFocus = options.trigger || document.activeElement;
      this.selectedVariantId = "";
      this.selectedShipping = "";
      this.step = "size";
      this.transitioning = false;

      this.applyAccent(this.config.accentColor);

      if (this.productEl) {
        if (options.productTitle) {
          this.productEl.textContent = options.productTitle;
          this.productEl.hidden = false;
        } else {
          this.productEl.textContent = "";
          this.productEl.hidden = true;
        }
      }

      if (this.sizeMount) {
        this.sizeMount.innerHTML = "";
        if (options.template) {
          this.sizeMount.appendChild(options.template.content.cloneNode(true));
        }
      }

      this.sizeStep.hidden = false;
      this.sizeStep.classList.add("is-active");
      this.sizeStep.classList.remove("is-leaving", "is-entering");
      this.shippingStep.hidden = true;
      this.shippingStep.classList.remove("is-active", "is-leaving", "is-entering");
      if (this.estimateWrap) this.estimateWrap.hidden = true;
      this.showError("");
      this.setStepChrome("size");

      var checked = this.sizeMount.querySelector(
        'input[type="radio"]:checked:not(:disabled)'
      );
      if (checked) {
        this.onSizeSelected(checked);
      }

      this.root.hidden = false;
      document.body.classList.add("ks-box-size-atc-workflow-open");

      var self = this;
      requestAnimationFrame(function () {
        self.root.classList.add("is-open");
        var focusTarget =
          self.sizeMount.querySelector(
            'input[type="radio"]:checked:not(:disabled)'
          ) ||
          self.sizeMount.querySelector('input[type="radio"]:not(:disabled)');
        if (focusTarget) {
          focusTarget.focus({ preventScroll: true });
        } else {
          self.primaryBtn?.focus?.({ preventScroll: true });
        }
      });
    },

    close: function () {
      if (!this.root) return;

      this.root.classList.remove("is-open");
      document.body.classList.remove("ks-box-size-atc-workflow-open");

      var previousFocus = this.previousFocus;
      this.previousFocus = null;

      setTimeout(
        function () {
          this.root.hidden = true;
          if (this.sizeMount) this.sizeMount.innerHTML = "";
        }.bind(this),
        280
      );

      try {
        previousFocus?.focus?.({ preventScroll: true });
      } catch (_) {
        previousFocus?.focus?.();
      }
    },
  };

  function findTemplateForForm(formId) {
    if (!formId) return null;
    return document.querySelector(
      'template[data-ks-box-size-workflow-template][data-ks-box-size-form="' +
        formId +
        '"]'
    );
  }

  function onOpenClick(event) {
    var trigger = event.target.closest("[data-ks-box-size-atc-open]");
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var config = getConfig(trigger);
    if (config && config.enable === false) return;

    var formId = trigger.getAttribute("data-ks-box-size-form");
    var form = formId ? document.getElementById(formId) : null;
    var template = findTemplateForForm(formId);

    if (!form || !template) return;

    var cardRoot = trigger.closest("[data-ks-grid-card-quick-add]");
    var qtyInput = cardRoot
      ? cardRoot.querySelector("[data-ks-grid-card-qty-input]")
      : null;
    if (qtyInput && cardRoot) {
      var hidden = form.querySelector("[data-ks-grid-card-qty-field]");
      if (hidden) hidden.value = String(qtyInput.value || "1");
    }

    WorkflowUI.open({
      trigger: trigger,
      form: form,
      template: template,
      productTitle: trigger.getAttribute("data-ks-box-size-product-title") || "",
      config: config,
    });
  }

  function bind() {
    if (document.body.dataset.ksBoxSizeAtcWorkflowBound === "true") return;
    document.body.dataset.ksBoxSizeAtcWorkflowBound = "true";
    document.addEventListener("click", onOpenClick);
  }

  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    bind();
  } else {
    document.addEventListener("DOMContentLoaded", bind);
  }

  window.KSBoxSizeAtcWorkflow = {
    open: function (options) {
      WorkflowUI.open(options || {});
    },
    close: function () {
      WorkflowUI.close();
    },
  };
})();
